import React from 'react';
import ReactToPrint from 'react-to-print';
import { RenderizarReporte } from './RenderizarReporte';

/**
 * Clase que carga el componente de Renderizar el reporte crediticio
 * y agrega la funcionalidad de Imprimir el documento.
 */
export class ReporteCrediticio extends React.PureComponent {
  
    render() {
       
        return (

           
            <div>
                
                <div className="card shadow mb-4">
                    <div className="card-header sticky-top">
                        <div className="text-right">
                            <ReactToPrint
                                trigger={() => {
                                    return (
                                        <button className="btn btn-primary btn-icon-split text-center">
                                            <span className="icon text-white-50">
                                                <i className="fas fa-print"></i>
                                            </span>
                                            <span className="text">Imprimir</span>
                                        </button>
                                    );
                                }}
                                content={() => this.componentRef}
                            />
                        </div>
                    </div>
                    <div className="card-body overflow-auto">
                        <RenderizarReporte ref={el => (this.componentRef = el)} />
                    </div>
                </div>
            </div>



        );
    }
}

export default ReporteCrediticio;